var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-pagination',{attrs:{"color":"#338A68","value":_vm.current_page,"length":_vm.last_page,"total-visible":15,"prev-icon":"mdi-menu-left","next-icon":"mdi-menu-right"},on:{"input":_vm.nextPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }